// extracted by mini-css-extract-plugin
module.exports = {"main-text":"_1APWw","mainText":"_1APWw"};